import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "film-entry" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "details" }

import { inject, onMounted, ref, useTemplateRef, watch } from 'vue'
import { RunInputContext } from '@/services/RunInputService';
import { SavedFilmsService, UploadedSavedFilmDto } from '@/api';
import { ToastInterface } from 'vue-toastification';



export default /*@__PURE__*/_defineComponent({
  __name: 'FilmUploader',
  props: {
    context: {},
    horizontal: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const toast = inject<ToastInterface>("toast");

const uploadedFilms = ref<UploadedSavedFilmDto[]>([]);

const fileInput = useTemplateRef('fileInput');


const moviePaths = {
    "4a103000-0000-3000-8000-000000000000": "Halo3",
    "4a100d57-0000-3000-8000-000000000000": "Halo3ODST",
    "4a102eac-0000-3000-8000-000000000000": "HaloReach",
    "4a104000-0000-3000-8000-000000000000": "Halo4",
}

onMounted(() => {
    
})

function onChange() {
    emit("change", props.context);
}

watch(props.context.savedFilmAttachmentIds, async ids => {
    if(!ids) {
        uploadedFilms.value = [];
    }

    for(let id of ids) {
        if(uploadedFilms.value.findIndex(f => f.Id == id) == -1) {
            let resp = await SavedFilmsService.getSavedFilmInfo(id);
            uploadedFilms.value.push(resp);
        }
    }
}, { deep: true, immediate: true });

async function handleUpload(e: Event) {
    const target = e.target as HTMLInputElement;
    const file = target.files?.[0];
    if (!file) return;

    const data = new FormData();

    data.append("Filename", file.name);
    data.append("File", file);

    try {
        const resp = await SavedFilmsService.uploadSavedFilm(data);

        if(resp && resp.Id) {
            props.context.savedFilmAttachmentIds.push(resp.Id);
            uploadedFilms.value.push(resp);
            onChange();
        }
    } catch (ex) {
        toast!.error("Failed to upload film. If this is a valid MCC saved film, please contact the tech team to support your film properly");
    }
}

async function removeFilm(film: UploadedSavedFilmDto) {
    const loc = uploadedFilms.value.findIndex(f => f.Id == film.Id);
    uploadedFilms.value.splice(loc, 1)

    const attLoc = props.context.savedFilmAttachmentIds.indexOf(film.Id!);
    props.context.savedFilmAttachmentIds.splice(attLoc, 1);

    onChange();
}

function inputClick(ev: MouseEvent) {
    let gameDir = moviePaths[props.context.gameId];
    let path = `%AppData%\\..\\LocalLow\\MCC\\Temporary\\UserContent\\${gameDir}\\Movie`;

    try {    
        toast!.info(`Copying ${path} to clipboard, paste in the file dialog`)
        setTimeout(() => { 
            navigator.clipboard.writeText(path);
            fileInput.value?.click();
        }, 100);
    } catch {

    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.context.requiresSavedFilm && uploadedFilms.value.length == 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "warning-text",
          style: _normalizeStyle(_ctx.horizontal ? 'text-align: right' : '')
        }, "A Theater File is required for this submission", 4))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "uploader-root",
      style: _normalizeStyle(_ctx.horizontal ? 'flex-direction: row-reverse; align-items: stretch;' : 'flex-direction: column')
    }, [
      (uploadedFilms.value.length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "film-list",
            style: _normalizeStyle(_ctx.horizontal ? 'flex-direction: row;' : '')
          }, [
            (!_ctx.horizontal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Uploaded Films:"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadedFilms.value, (film) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("button", {
                  type: "button",
                  class: "button ghost is-primary",
                  onClick: () => removeFilm(film)
                }, "X", 8, _hoisted_3),
                _createElementVNode("div", _hoisted_4, _toDisplayString(film.Game) + "(v" + _toDisplayString(film.Version) + ") - " + _toDisplayString(film.Scenario), 1),
                _createElementVNode("div", _hoisted_5, "Created at " + _toDisplayString(film.FilmTimestamp), 1)
              ]))
            }), 256))
          ], 4))
        : _createCommentVNode("", true),
      (moviePaths[_ctx.context.gameId] || _ctx.context.requiresSavedFilm)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "button upload-button",
            style: _normalizeStyle(_ctx.horizontal ? 'height: unset;' : 'width: 100%;'),
            onClick: inputClick
          }, " Upload Film / Theater File ", 4))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        type: "file",
        onChange: _cache[0] || (_cache[0] = e => handleUpload(e)),
        ref_key: "fileInput",
        ref: fileInput,
        style: {"display":"none"}
      }, null, 544)
    ], 4)
  ]))
}
}

})